module.exports = __webpack_public_path__ + "8fffe4601ae13bca5886c6d2f0e06da7.svg";